import { IPaginationParams, PaginationResult } from './api';

export type CommonListParams<T extends Record<any, any> = any> = IPaginationParams<T>;

export type CommonListResponse<T = any> = PaginationResult<T>;

export enum LocalStorageKey {
  TiangongTheme = 'tiangong-theme',
  TiangongPhone = 'tiangong-phone',
  TiangongRegion = 'tiangong-region',
  TiangongShort = 'tiangong-short',
  /** 对内任务列表左栏拖拽宽度(px) */
  TiangongTaskListWidth = 'tiangong-task-list-width',
  /** 对内任务列表「仅查看待审核任务」开关 */
  TiangongTaskOnlyUncheck = 'tiangong-task-only-uncheck',
}

// 大多数场景下标识唯一目标的属性类型
export interface Identity {
  id: number;
  name: string;
}
